// Which frame the browser gets, from the *real* viewport width (not the
// clamped Dimensions the app sees). See docs/PLAN_web-app.md §4.2.
//
//   phone    < 768px   the app exactly as on a phone, full width
//   tablet   768–1023  centred canvas, bottom nav kept
//   desktop  ≥ 1024    sidebar + wide content area

import { useEffect, useState } from 'react';

export type LayoutMode = 'phone' | 'tablet' | 'desktop';

export const DESKTOP_MIN_WIDTH = 1024;
export const TABLET_MIN_WIDTH = 768;

export function layoutModeFor(width: number): LayoutMode {
  if (width >= DESKTOP_MIN_WIDTH) return 'desktop';
  if (width >= TABLET_MIN_WIDTH) return 'tablet';
  return 'phone';
}

function currentWidth(): number {
  return typeof window === 'undefined' ? 0 : window.innerWidth;
}

export function useLayoutMode(): LayoutMode {
  const [mode, setMode] = useState<LayoutMode>(() => layoutModeFor(currentWidth()));
  useEffect(() => {
    const onResize = () => setMode(layoutModeFor(currentWidth()));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return mode;
}
